import {createHash} from '@apollo/utils.createhash';
import {operationRegistrySignature} from '@apollo/utils.operationregistrysignature';
import {DocumentNode} from 'graphql';

export default function getOperationSignature(doc: DocumentNode, operationName: string): string {
  const printed = operationRegistrySignature(doc, operationName, {
    preserveStringAndNumericLiterals: true,
  });

  return createHash('sha256').update(printed).digest('hex');
}
